
<div class="auth-section bg-light">
    <div class="container">
        <div class="row" *ngIf="!deeplink_expired" style="max-width: 798px; margin-left: 350px;">
            <div class="col-md-12 col-sm-12 col-12  m-0 sign-in">

                <form [formGroup]="resetPasswordForm" (ngSubmit)="onSubmit()" class="p-5 bg-white box-effect">
                    <div *ngIf='message && loginSuccess' class="alert alert-success mb-md-3">
                        {{ message}}
                    </div>
                    <div *ngIf="message_error && !loginSuccess" class="alert alert-danger mb-md-3">
                      {{ message_error}}
                      </div>

                    <h1 class="lead mb-md-3 login-heading">Create New Password</h1>

           

                     <div class="row form-group">
                        <!-- New Password field -->
                        <div class="col-md-12 mb-3 mb-md-3 m-0">
                          <div *ngIf="resetPasswordForm.get('newPassword')?.hasError('invalidPassword')" class="text-danger">
                            Password must be at least 8 characters long and contain at least one capital letter, one small letter, one number, and one special character.
                          </div>
                          <label class="lbl_login" for="newPassword">New password</label>
                          
                          <div class="input-group">
                            <input [type]="showNewPassword ? 'text' : 'password'" id="newPassword" formControlName="newPassword" class="form-control">
                            <div class="input-group-append">
                              <span class="input-group-text" id="newPasswordEye" (click)="togglePasswordVisibility('newPassword')">
                                <fa-icon [icon]="['fas','eye']"></fa-icon>
                              </span>
                            </div>
                          </div>
                      
                          <!-- <div *ngIf="resetPasswordForm.get('newPassword')?.hasError('required')" class="text-danger"> -->
                            <!-- <div *ngIf="resetPasswordForm.get('newPassword')?.hasError('required') && resetPasswordForm.get('newPassword').touched" class="text-danger">
                            Password is required.
                          </div> -->
                          <div *ngIf="resetPasswordForm?.get('newPassword')?.hasError('required') && resetPasswordForm?.get('newPassword')?.touched" class="text-danger">
                            Password is required.
                          </div>
                        </div>
                      </div> 

                      


                      
                      <div class="row form-group">
                        <!-- Confirm Password field -->
                        <div class="col-md-12 mb-md-3">
                          <label class="lbl_login" for="confirmPassword">Confirm Password</label>
                      
                          <div class="input-group">
                            <input [type]="showConfirmPassword ? 'text' : 'password'" id="confirmPassword" name="confirmPassword" class="form-control input-login" formControlName="confirmPassword">
                            <div class="input-group-append">
                              <span class="input-group-text" id="confirmPasswordEye" (click)="togglePasswordVisibility('confirmPassword')">
                                <fa-icon [icon]="['fas','eye']"></fa-icon>
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                      

                    <div class="row form-group">
                        <div class="col-md-12 col-sm-12 loginbtn">
                            <button type="submit" class="btn btn-primary btn-signin">Submit</button>


                        </div>
                    </div>
                </form>


            </div>
        </div>

        <div class="row" *ngIf="deeplink_expired">
            <div class="text-center welcome-main-div">
                <div class="welcome-congratulations-div">
                    <li class="fa fa-exclamation-circle waring-icon"></li>
                </div>
                <div class="unauthorized-heading">Deeplink Token Expired</div>
            </div>
        </div>
    </div>
</div>